import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { JOB_OFFERS } from "../../../../../job-offers";

@Component({
  selector: "app-job-offers",
  templateUrl: "./job-offers.component.html",
  styleUrls: ["./job-offers.component.scss"],
  imports: [RouterLink],
})
export class JobOffersComponent {
  public jobOffers = JOB_OFFERS;
}
